import styled from "styled-components";

export const WalletTableContainer = styled("table")`
  width: 100%;
  margin: 10px 0;

  td {
    width: 25%;
    padding: 10px 5px;
    text-align: center;
  }
`;

export const TableHeader = styled("tr")`
  background: var(--blue-color-dark);
  color: white;
`;

export const TableContentRow = styled("tr")`
  &:nth-child(2n + 1) {
    background: var(--blue-color-light);
  }
`;

export const TableContentDetail = styled("td")`
  color: ${(props) =>
    props.isDeposit
      ? "var(--success-color)"
      : props.isWithdraw
      ? "var(--danger-color)"
      : "var(--blue-color-dark)"};
`;
